import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B03CardManagementPage } from '../b03-card-management/b03-card-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B03bCardInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b03b-card-info',
  templateUrl: 'b03b-card-info.html',
})
export class B03bCardInfoPage {

  private todo : FormGroup;
  loading: any;
  Status: any;

  cardData = {  CARD_NO:'',  
                CAR_PLATE:'',  CREDIT_LIMIT:'',
                BALANCE:'', CARD_ACTIVE:'', CORP_ID: ''
  }
  CARD_ID:any;
  actual_credit:any;
  public errorMessage: any = "";

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public loadingCtrl: LoadingController,
              public serviceapi: ServiceApiProvider, public alertCtrl : AlertController) {

    this.todo = this.formBuilder.group({
        cardNumber: ['', Validators.required], 
        carPlate: ['', Validators.required],
        creditLimit: ['', Validators.required],
        balance: ['', Validators.required],
        cardActive: ['', Validators.required],

    });

    this.CARD_ID = this.navParams.get('paramID');    //card ID

    let tbl = ["CARD"];
    let column = ["CARD_ID"];
    let value = [this.CARD_ID];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    this.serviceapi.readdata(json_data,"CARD","1","1").then((result) => {
        
      this.Status = result["Message"];
      console.log(result["Records"]);
      if (this.Status == "1"){
        this.loading.dismiss();

        let Records = result["Records"];
        this.cardData.CARD_NO = Records[0]["CARD_NO"];
        this.cardData.CAR_PLATE = Records[0]["CAR_PLATE"];
        this.cardData.CREDIT_LIMIT = Records[0]["CREDIT_LIMIT"];
        this.actual_credit = Records[0]["CREDIT_LIMIT"];
        this.cardData.BALANCE = Records[0]["BALANCE"];
        this.cardData.CARD_ACTIVE = Records[0]["CARD_ACTIVE"];
        this.cardData.CORP_ID = Records[0]["CORP_ID"];

      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B03bCardInfoPage');
  }

  deleteCard(){
    let confirm = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Are you sure you want to delete this card? This action cannot be undone.',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Disagree clicked');
          }
        }, 
        {
          text: 'Yes',
          handler: () => {
            console.log('Agree clicked');
              
            this.showLoader();
            this.serviceapi.deletedata('CARD', 'CARD_ID', this.CARD_ID).then((result) => {
          
              this.Status = result["Message"];
              if (this.Status == "1"){
                this.loading.dismiss();
                this.navCtrl.setRoot(B03CardManagementPage);
              }
              else {
                this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                this.loading.dismiss();
              }
            }, (err) => {
                this.errorMessage = "Loading Error. Please try again.";
                this.loading.dismiss();
            });
        
          }
        }
      ]
    });
    confirm.present();
    
  }

  blockCard(){
    this.navCtrl.setRoot(B03CardManagementPage);
  }

  updateCard(){
    this.showLoader();
    //if(this.actual_credit > parseFloat(this.cardData.CREDIT_LIMIT))
    this.cardData.BALANCE = ((parseFloat(this.cardData.CREDIT_LIMIT)-parseFloat(this.actual_credit))+parseFloat(this.cardData.BALANCE)).toString();
    if(parseFloat(this.cardData.BALANCE) < 0)
        this.cardData.BALANCE = "0";
      //else
    
    this.serviceapi.updatedata('CARD', 'CARD_ID', this.CARD_ID, this.cardData).then((result) => {
        
      this.Status = result["Message"];
      if (this.Status == "1"){
        this.loading.dismiss();
        this.navCtrl.setRoot(B03CardManagementPage);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
    
  }

  cancel(){
    this.navCtrl.pop();
  }

  goTo(){
    this.navCtrl.setRoot(B03CardManagementPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b03b-card-info/b03b-card-info.ts